import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import * as moment from 'moment-timezone';
import { Subject } from 'rxjs';
import DateHelper from 'src/app/helpers/date-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import LoggedAction from 'src/app/model/logged-action';
import Employee from 'src/app/model/product/employee';
import { HEIGHT_EQUIPMENT_OPTIONS } from 'src/app/model/product/product';
import Windowsticker from 'src/app/model/product/windowsticker/windowsticker';
import WindowStickerPlacement from 'src/app/model/product/windowsticker/windowsticker-placement';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { AuthService } from 'src/app/services/auth.service';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { ModalService } from 'src/app/services/modal.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { SubProject } from '../../../../model/project/sub-project';

@Component({
  selector: 'windowsticker-placement-form',
  templateUrl: './windowsticker-placement-form.component.html',
  styleUrls: ['./windowsticker-placement-form.component.scss'],
})
export class WindowstickerPlacementFormComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @ViewChild('actualPlacementInput')
  public actualPlacementInput: ElementRef<HTMLInputElement>;

  @Input()
  public inputProject: SubProject;
  @Input()
  public inputProduct: Windowsticker;
  @Input()
  public inputProjectPlacement: ProjectPlacement;
  @Output()
  public outputProduct = new EventEmitter();

  public extraInfoSiteChangeSub = new Subject<string>();

  public hours: string[] = [];
  public minutes: string[] = [];
  public placement: WindowStickerPlacement;
  public heightEquipmentOptions = HEIGHT_EQUIPMENT_OPTIONS;
  public employeeChoices: Employee[] = [];
  public externalSupplierEmployeeChoices: Employee[];

  requestedDateDisplay: string;
  invoiceDisables: boolean;

  DEFAULT_EXECUTION_TIME = '00:00';
  executionTime = this.DEFAULT_EXECUTION_TIME;

  constructor(
    private authService: AuthService,
    private datePipe: DatePipe,
    private modalService: ModalService,
    private employeeChoicesService: EmployeeChoicesService,
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit() {
    if (this.inputProduct.productPlacement != null) {
      this.placement = <WindowStickerPlacement>(
        this.inputProduct.productPlacement
      );
    } else {
      this.placement = new WindowStickerPlacement();
      this.placement.productPlacementType = 'WindowStickerPlacement';
      this.placement.kilometersTo = this.inputProjectPlacement.kilometersTo;
      this.inputProduct.productPlacement = this.placement;
    }
    if (
      !!this.inputProduct &&
      !!this.inputProduct.productPlacement &&
      !!this.inputProduct.productPlacement.executionTime
    ) {
      this.executionTime =
        this.inputProduct.productPlacement.executionTime.slice(0, 5);
    }
    this.hours = ['0', '1', '2', '3', '4', '5', '6', '7', '8'];
    this.minutes = Array(60)
      .fill(1)
      .map((x, y) => String(x + y - 1).padStart(2, '0'));
    this.initOverrideableFields();
    this.getEmployees();
    this.calculateRequestedDateDisplay();
    this.calculateInvoiceDisables();
    this.addSubscription(
      this.projectDisplayObservableService.getProjectPlacementRequestDateChangedSubscribable(),
      () => {
        this.calculateRequestedDateDisplay();
      }
    );
    this.addSubscription(
      this.projectDisplayObservableService.getInvoiceSentSubscribable(),
      () => {
        this.calculateInvoiceDisables();
      }
    );
  }

  initOverrideableFields() {
    if (this.inputProduct.productPlacement.actualPlacementDate == null) {
      this.inputProduct.productPlacement.actualPlacementDate =
        this.inputProjectPlacement.placementEarliestDate;
    }
    if (this.inputProduct.productPlacement.extraInfoSite == null) {
      this.inputProduct.productPlacement.extraInfoSite =
        this.inputProjectPlacement.extraInfoSite;
    }
  }

  getEmployees() {
    this.addSubscription(
      this.employeeChoicesService.getPlacerChoicesSubscribable(),
      (result) => {
        this.employeeChoices = <Employee[]>result;
      }
    );
    this.addSubscription(
      this.employeeChoicesService.getExternalSupplierChoicesSubscribable(),
      (result) => {
        this.externalSupplierEmployeeChoices = <Employee[]>result;
      }
    );
  }

  placerChange(value) {
    this.projectDisplayObservableService.getPlacersChangedSubscribable().next();
    this.outputProduct.emit();
  }

  setHours(event) {
    this.outputProduct.emit();
  }

  setMinutes(event) {
    this.outputProduct.emit();
  }

  compareEnums(e1, e2) {
    return e1 != null && e2 != null && e1.name === e2.name;
  }

  compareEntities(o1, o2) {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      if (o1.id === o2.id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  compareNumbers(n1, n2) {
    return n1 == n2;
  }

  getChosenPlacers() {
    if (
      this.inputProduct.productPlacement == null ||
      this.inputProduct.productPlacement.placers == null ||
      this.inputProduct.productPlacement.placers.length === 0
    ) {
      return 'Geen medewerkers gekozen';
    }

    let toReturn = '';
    for (
      let i = 0;
      i < this.inputProduct.productPlacement.placers.length;
      i++
    ) {
      let placer = this.inputProduct.productPlacement.placers[i];
      if (placer.user == null) {
        continue;
      }
      if (i > 0) {
        toReturn += ', ' + placer.user.firstName + ' ' + placer.user.lastName;
      } else {
        toReturn += placer.user.firstName + ' ' + placer.user.lastName;
      }
    }
    return toReturn;
  }

  installerInfoChange(value) {
    this.inputProduct.productPlacement.installerInfo = value;
    this.outputProduct.emit();
  }

  workHeightChange(event) {
    this.outputProduct.emit();
  }

  heightEquipmentChange(event) {
    this.outputProduct.emit();
  }

  hoogwerkerChanged(event) {
    this.inputProduct.productPlacement.extraHoogwerker = event;
    this.outputProduct.emit();
  }

  hoogwerkerTextChanged(event) {
    this.inputProduct.productPlacement.extraHoogwerkerDescription = event;
    this.outputProduct.emit();
  }

  hoogwerkerDoneChanged(event) {
    this.inputProduct.productPlacement.extraHoogwerkerDone = event;
    this.outputProduct.emit();
  }

  extraHoogwerkerEmployeeChange() {
    this.outputProduct.emit();
  }

  extraHoogwerkerDeadlineChange(event) {
    this.inputProduct.productPlacement.extraHoogwerkerDeadline = event.value;
    this.outputProduct.emit();
  }

  placeASAP(event) {
    this.inputProduct.productPlacement.placeASAP = event;
    if (event) {
      delete this.inputProduct.productPlacement.actualPlacementDate;
    }
    this.outputProduct.emit();
  }

  actualPlacementDateChange(event) {
    let newDate = event.value;
    if (
      this.inputProjectPlacement.placementEarliestDate != null &&
      moment
        .tz(newDate, 'Europe/Brussels')
        .isBefore(
          moment.tz(
            this.inputProjectPlacement.placementEarliestDate,
            'Europe/Brussels'
          ),
          'day'
        )
    ) {
      this.modalService.confirmDialog(
        'Datum vroeger dan gevraagde datum',
        'De geselecteerde datum (' +
          DateHelper.formatDate(newDate) +
          ') is vroeger dan de gevraagde datum (' +
          DateHelper.formatDate(
            this.inputProjectPlacement.placementEarliestDate
          ) +
          '). Bent u zeker dat u deze datum wilt selecteren?',
        (c) => {
          if (c) {
            if (
              this.inputProjectPlacement.appointment &&
              this.inputProduct.productPlacement.actualPlacementDate != null
            ) {
              this.checkAppointmentPlacement(newDate);
            } else {
              this.inputProduct.productPlacement.actualPlacementDate = newDate;
              this.outputProduct.emit();
            }
          } else {
            this.actualPlacementInput.nativeElement.value =
              DateHelper.formatDate(
                this.inputProduct.productPlacement.actualPlacementDate
              );
          }
        }
      );
    } else if (
      this.inputProjectPlacement.appointment &&
      this.inputProduct.productPlacement.actualPlacementDate != null
    ) {
      this.checkAppointmentPlacement(newDate);
    } else {
      this.inputProduct.productPlacement.actualPlacementDate = newDate;
      this.outputProduct.emit();
    }
  }

  checkAppointmentPlacement(newDate) {
    this.modalService.confirmDialog(
      'Opgelet!',
      'Er is een afspraak nodig voor deze plaatsing. Contacteer de klant om deze ook te verzetten indien u de plaatsingsdatum aanpast.',
      (c) => {
        if (c) {
          this.inputProduct.productPlacement.actualPlacementDate = newDate;
          this.outputProduct.emit();
        } else {
          this.actualPlacementInput.nativeElement.value = DateHelper.formatDate(
            this.inputProduct.productPlacement.actualPlacementDate
          );
        }
      }
    );
  }

  actualPlacementDateConfirmedChange(value) {
    this.inputProduct.productPlacement.actualPlacementDateConfirmed = value;
    this.outputProduct.emit();
  }

  installerMinuteBudgetChanged(event) {
    this.outputProduct.emit();
  }

  kilometersToChanged(event) {
    this.outputProduct.emit();
  }

  saveInsideOutside(event) {
    this.placement.inside = event;
    this.projectDisplayObservableService
      .getProductPlacementVariableChangedSubscribable()
      .next();
    this.outputProduct.emit();
  }

  saveWetDry(event) {
    this.placement.wet = event;
    this.projectDisplayObservableService
      .getProductPlacementVariableChangedSubscribable()
      .next();
    this.outputProduct.emit();
  }

  installerFeedbackChange(event) {
    this.inputProduct.productPlacement.installerFeedback = event;
    this.outputProduct.emit();
  }

  executionCompleteChange(event) {
    this.inputProduct.productPlacement.executionComplete = event;
    if (event) {
      this.inputProduct.productPlacement.executionDate = new Date();
      let hours =
        this.inputProduct.productPlacement.executionDate.getHours() < 10
          ? '0' + this.inputProduct.productPlacement.executionDate.getHours()
          : this.inputProduct.productPlacement.executionDate.getHours();
      let minutes =
        this.inputProduct.productPlacement.executionDate.getMinutes() < 10
          ? '0' + this.inputProduct.productPlacement.executionDate.getMinutes()
          : this.inputProduct.productPlacement.executionDate.getMinutes();

      this.executionTimeChange(hours + ':' + minutes);
      this.inputProduct.productPlacement.placedRegistration =
        new LoggedAction();
      this.inputProduct.productPlacement.placedRegistration.date = new Date();
      this.inputProduct.productPlacement.placedRegistration.by =
        this.authService.getAuthenticatedUser();
    } else {
      this.inputProduct.productPlacement.executionDate = null;
      this.inputProduct.productPlacement.executionTime = null;
      this.inputProduct.productPlacement.placedRegistration = null;
    }
    this.projectDisplayObservableService
      .getProductExecutedSubscribable()
      .next();
    this.outputProduct.emit();
  }

  executionCompleteInfoChange(event) {
    this.inputProduct.productPlacement.executionCompleteInfo = event;
    this.outputProduct.emit();
  }

  parkingBanChanged(value) {
    this.inputProduct.productPlacement.parkingBan = value;
    this.outputProduct.emit();
  }

  extraInfoParkingBanChanged(value) {
    this.inputProduct.productPlacement.extraInfoParkingBan = value;
    this.outputProduct.emit();
  }

  ParkingBanDoneChanged(value) {
    this.inputProduct.productPlacement.parkingBanDone = value;
    this.outputProduct.emit();
  }

  parkingBanEmployeeChange() {
    this.outputProduct.emit();
  }

  parkingBanDeadlineChange(event) {
    this.inputProduct.productPlacement.parkingBanDeadline = event.value;
    this.outputProduct.emit();
  }

  saveWindowObstacle(value) {
    this.placement.windowObstacle = value;
    this.projectDisplayObservableService
      .getProductPlacementVariableChangedSubscribable()
      .next();
    this.outputProduct.emit();
  }

  extraInfoWindowObstacleChange(value) {
    this.placement.extraInfoWindowObstacle = value;
    this.projectDisplayObservableService
      .getProductPlacementVariableChangedSubscribable()
      .next();
    this.outputProduct.emit();
  }

  saveOldStickerPresent(value) {
    this.placement.oldStickerPresent = value;
    this.projectDisplayObservableService
      .getProductPlacementVariableChangedSubscribable()
      .next();
    this.outputProduct.emit();
  }

  extraInfoOldStickerPresentChange(value) {
    this.placement.extraInfoOldStickerPresent = value;
    this.projectDisplayObservableService
      .getProductPlacementVariableChangedSubscribable()
      .next();
    this.outputProduct.emit();
  }

  alignmentChange(value) {
    this.placement.alignment = value;
    this.outputProduct.emit();
  }

  needSiteVisitChange(value) {
    this.inputProduct.productPlacement.needSiteVisit = value;
    this.outputProduct.emit();
  }

  extraInfoNeedSiteVisitChange(value) {
    this.inputProduct.productPlacement.extraInfoNeedSiteVisit = value;
    this.outputProduct.emit();
  }

  needExtraSupplierChange(value) {
    this.inputProduct.productPlacement.needExtraSupplier = value;
    this.outputProduct.emit();
  }

  needExtraSupplierDoneChange(value) {
    this.inputProduct.productPlacement.needExtraSupplierDone = value;
    this.outputProduct.emit();
  }

  extraInfoNeedExtraSupplierChange(value) {
    this.inputProduct.productPlacement.extraInfoNeedExtraSupplier = value;
    this.outputProduct.emit();
  }

  extraSupplierEmployeeChange() {
    this.outputProduct.emit();
  }

  extraSupplierDeadlineChange(event) {
    this.inputProduct.productPlacement.extraSupplierDeadline = event.value;
    this.outputProduct.emit();
  }

  needExtraMaterialsChange(value) {
    this.inputProduct.productPlacement.needExtraMaterials = value;
    this.outputProduct.emit();
  }

  needExtraMaterialsDoneChange(value) {
    this.inputProduct.productPlacement.needExtraMaterialsDone = value;
    this.outputProduct.emit();
  }

  extraInfoNeedExtraMaterialsChange(value) {
    this.inputProduct.productPlacement.extraInfoNeedExtraMaterials = value;
    this.outputProduct.emit();
  }

  extraMaterialsEmployeeChange() {
    this.outputProduct.emit();
  }

  extraMaterialsDeadlineChange(event) {
    this.inputProduct.productPlacement.extraMaterialsDeadline = event.value;
    this.outputProduct.emit();
  }

  visibleDamageChange(value) {
    this.placement.visibleDamage = value;
    this.outputProduct.emit();
  }

  extraInfoVisibleDamageChange(value) {
    this.placement.extraInfoVisibleDamage = value;
    this.outputProduct.emit();
  }

  executionDateChange(value) {
    this.outputProduct.emit();
  }

  executionTimeChange(value) {
    this.inputProduct.productPlacement.executionTime = value;
    this.outputProduct.emit();
  }

  extraInfoSiteChange(value) {
    this.inputProduct.productPlacement.extraInfoSite = value;
    this.outputProduct.emit();
  }

  calculateInvoiceDisables(): boolean {
    if (this.inputProject.projectInvoices == null) {
      this.invoiceDisables = false;
      return;
    }
    for (let i of this.inputProject.projectInvoices) {
      if (i.type === 'PlacementInvoice' && i.sentDate != null) {
        this.invoiceDisables = true;
        return;
      }
    }
    this.invoiceDisables = false;
  }

  calculateRequestedDateDisplay() {
    if (this.inputProject.projectPlacement == null) {
      this.requestedDateDisplay = 'Geen';
      return;
    }
    if (this.inputProject.projectPlacement.placementEarliestDate == null) {
      this.requestedDateDisplay = this.inputProjectPlacement.placeASAP
        ? 'ASAP'
        : 'Geen';
      return;
    }
    this.requestedDateDisplay = this.datePipe.transform(
      this.inputProjectPlacement.placementEarliestDate,
      'dd/MM/yyyy'
    );
  }

  copyProjectPlacementDate() {
    let dateCopy = new Date(this.inputProjectPlacement.placementEarliestDate);
    this.inputProduct.productPlacement.actualPlacementDate = dateCopy;
    this.outputProduct.emit();
  }

  trackById(index: number, obj: any): number {
    return GeneralHelper.trackById(index, obj);
  }
}
